let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("gsMsE")).then(() => parcelRequire('j7GCD'));